import * as CONSTANTS from '../actions/actionTypes';
import config from "../../Api";
import { toastr } from "react-redux-toastr";
import { default as apiEndPoints } from "../../Routes/StudentSide/utils/apiEndPoints";
import axios from 'axios';

let CMS_TOKEN="eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YzBmY2I1OGExMGVlNjI5NjgxYWU4NjYiLCJuYW1lIjoiQ0xQIE1hc3RlciIsImVtYWlsIjoiZW5naW5lZXJpbmdAY2xhc3NwbHVzLmNvIiwiY29udGFjdCI6eyJjb3VudHJ5Q29kZSI6OTEsIm1vYmlsZSI6ODA3Njc2NzMxNX0sIm9yZ2FuaXphdGlvbiI6eyJpZCI6MSwiY29kZSI6ImNscCJ9LCJyb2xlIjpbImFkbWluIl0sImFsbG93U2hhcmluZyI6ZmFsc2UsImFsbG93R3BzY1R5cGUiOmZhbHNlLCJpYXQiOjE2MjYxNzI4MzcsImV4cCI6MTYyNzkwMDgzN30.mq8tHOyMdDjrtoI0pYTpJGnX7ALYDc6o2BYRVwpVo4jAdnMxKsUMcYaMDpDXF3-9";
let STUDENT_SIDE="eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE3OTc5NzU3LCJuYW1lIjoiQW5raXQgQ2hhd2xhIiwiZW1haWwiOiJhbmtpdC5jaGF3bGFAY2xhc3NwbHVzLmNvIiwibW9iaWxlIjoiOTE5OTkyMzExNTk2Iiwic3R1ZGVudElkIjoxNDQ3OTYxMiwidGltZXN0YW1wIjoxNjI1NzQ3NTc4MDkxLCJvcmdJZCI6MSwic2hhcmVkVGVzdElkIjoiNjBlZDM3NmRmNTlmNmM2MWFhNDk3YTQ1IiwibnVtYmVyT2ZBdHRlbXB0cyI6LTEsInRlc3RJZCI6IjVlMTQyYWU3NmY4MTg0NWM5NzE0ZGQzNyIsImJ1aWxkVHlwZSI6MSwiaWF0IjoxNjI2MTgyMzgzLCJleHAiOjE2Mjc5MTAzODMsInR5cGUiOjN9.9ZzaiZG_CamNPvkNcqW_J2kLVhxKlJqjB4XYPKXvKfHLufDndaUTl4VuJwUSSGqo";

export const fetchFreeTest = (payload) => (dispatch,getState) => {
    let state = getState();

    dispatch({
        type: CONSTANTS.SET_IS_FREE_LOADING,
        payload: true
    })

    axios({
        method: "GET",
        url: `${config.API_URL_STUDENT}${apiEndPoints.STUDENT_SIDE.FREE_TEST_LIST.url(payload)}`,
        headers: {
          "x-cms-access-token": state.loginReducer.studentSideToken?state.loginReducer.studentSideToken:payload.token
        },
      })
        .then((response) => {
            if(!payload.isUpcoming)
            {
                dispatch({
                    type: CONSTANTS.SET_STUDENT_FREE_TEST,
                    payload: {
                        ...response.data.data,
                        offset: payload.offset,
                        search: payload.search,
                    }
                })  
            }
            else{ console.log(response.data.data)
                dispatch({
                    type: CONSTANTS.SET_STUDENT_FREE_TEST_UPCOMING,
                    payload: {
                        ...response.data.data,
                        offset: payload.offset,
                        search: payload.search,
                    }
                })
            }     
        })
        .catch((err) => {
            dispatch({
                type: CONSTANTS.SET_IS_LOADING,
                payload: false
            })
            toastr.error("ERROR", err.response.data.message);
        });
}

export const fetchAttemptedTest = (payload) => (dispatch,getState) => {
    let state = getState();
        
    dispatch({
        type: CONSTANTS.SET_IS_LOADING,
        payload: true
    })  
    axios({
        method: "GET",
        url: `${config.API_URL_STUDENT}${apiEndPoints.STUDENT_SIDE.ATTEMPTED_TEST_LIST.url(payload)}`,
        headers: {
          "x-cms-access-token": state.loginReducer.studentSideToken?state.loginReducer.studentSideToken:payload.token
        },
      })
        .then((response) => {
            dispatch({
                type: CONSTANTS.SET_STUDENT_ATTEMPTED_TEST,
                payload: {
                    ...response.data.data,
                    offset: payload.offset,
                    search: payload.search,
                }
            })     
        })
        .catch((err) => {
            dispatch({
                type: CONSTANTS.SET_IS_LOADING,
                payload: false
            })
            toastr.error("ERROR", err.response.data.message);
        });
}

export const fetchStudentStats = (payload) => (dispatch,getState) => {
    let state = getState();
        
    dispatch({
        type: CONSTANTS.SET_IS_LOADING,
        payload: true
    })

    axios({
        method: "POST",
        url: `${config.API_URL_STUDENT}${apiEndPoints.STUDENT_SIDE.STUDENT_TEST_DETAILS.url(payload)}`,
        data: {
            sharedTestId: payload.batchTestId,
        },
        headers: {
        //   "x-cms-access-token": state.loginReducer.studentSideToken
          "x-cms-access-token": payload.token
        },
      })
        .then((response) => {
            dispatch({
                type: CONSTANTS.SET_STUDENT_TEST_DETAILS,
                payload: {
                    ...response.data.data,
                }
            })
        })
        .catch((err) => {
          
            dispatch({
                type: CONSTANTS.SET_IS_LOADING,
                payload: false
            })
            toastr.error("ERROR", err.response.data.message);
        });
}

export const resetFreeTest = (payload) => {
    return {
        type: CONSTANTS.EMPTY_FREE_TEST,
        payload
    }

}